export default __webpack_public_path__ + "static/banner-2112a01d9b2653c83b2dda05dff32bc4.jpg";